import React, { useState, useEffect, useCallback } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import { useTranslation, withTranslation } from "react-i18next";
import { message } from "antd";

import * as configApi from "../../config/configApi.js";
import { GetResultPatient } from "../../Api/AppBackend/ListSid";
import PatientInfo from "./ResultModal/PatientInfor";
import Ordinary from "./ResultModal/Ordinary";
import Microorganism from "./ResultModal/Microorganism";

const ResultModalV2 = ({ isOpen, setIsOpen, itemView }) => {
  const { t } = useTranslation(["dashboard"]);
  const [data, setData] = useState(null);

  const fetchPatientResult = useCallback(async () => {
    if (!itemView) return;

    try {
      const payload = {
        sid: itemView.sid,
        siteCode: itemView.siteCode,
        id: itemView.rowguid,
      };

      const res = await GetResultPatient(payload);
      if (res?.data?.isSuccess) {
        setData(res.data.data);
      } else {
        message.error(res?.data?.err?.msgString || t("Failed to load data"));
        setData(null);
      }
    } catch (err) {
      console.error("fetchPatientResult error:", err);
      message.error("CallApi_GetResultPatient error");
      setData(null);
    }
  }, [itemView, t]);

  useEffect(() => {
    if(isOpen){
        fetchPatientResult();
    }
  }, [isOpen]);

  const patientData = data?.[0] || {};

  return (
    <Modal isOpen={isOpen} style={{ maxWidth: 1000 }}>
      <ModalHeader style={{ background: configApi.USE_COLOR, color: "#fff" }}>
        {t("VIEW RESULTS")}
      </ModalHeader>
      <AvForm>
        <ModalBody>
          <PatientInfo t={t} patientInfo={patientData} />
          {
            patientData.listOrder?.some(item => item.listTestOrder?.length > 0) &&(
                <Ordinary t={t} data={patientData} />
            )
          }
          {
            patientData.listOrder?.some(item => item.listTestOrderMB?.length > 0) &&(
                <Microorganism t={t} data={patientData} />
            )
          }
        </ModalBody>
        <ModalFooter>
          <Row
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              paddingRight: "10px",
            }}
          >
            <Button
              color="danger"
              className="ml-2"
              onClick={() => setIsOpen(false)}
            >
              <span className="mr-2 lnr lnr-exit"></span>
              {t("Close")}
            </Button>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

export default withTranslation(["dashboard"])(ResultModalV2);
